import { TreeItemType } from '../enums';
import { ITreeItem } from '../interfaces';
import { GroupModel } from './GroupModel';
import { NamespaceModel } from './NamespaceModel';

/**
 * * Модель очереди задач
 */
export class QueueTasksModel implements ITreeItem {
  /**ID задачи */
  Id!: string;
  /**Имя */
  Name!: string;
  /**ID рабочей области */
  NamespaceId?: string;
  /**ID родительской группы */
  ParentGroupId?: number;
  /**Порядковый номер */
  Number?: number;
  /**Тип родителя */
  ParentType?: TreeItemType;
  /**Есть ли задачи в очереди */
  HasTask?: boolean;
  /**Админ неймспейса */
  IsAdminNamespace: boolean = false;
  /**Тип в дереве */
  readonly Type: TreeItemType = TreeItemType.Queue;
  IsConfigured?: boolean;
  TaskCount?: number = 0;
  /**Является ли объект рабочей областью */
  isNamespace = (): this is NamespaceModel => false;
  /**Является ли объект группой */
  isGroup = (): this is GroupModel => false;
  /**Является ли объект очередью */
  isQueue = (): this is QueueTasksModel => true;

  /**Выбран в сайдбаре */
  isSelectedInSidebar: boolean = false;

  constructor(obj?: Partial<QueueTasksModel>) {
    if (obj) Object.assign(this, { ...obj, Type: this.Type });
  }
}
